query HeaderInfo($id: UUID!) {
  entityDocument(id: $id) {
    __typename
    id
    documentAppliedAmounts {
      __typename
      remainingTotal
    }
    currency {
      __typename
      isoCode
    }
    indexAmount
  }
}
